// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2i_WV","productName":"Table_productName__3vx58"};